<div>
    <!-- <p class="common-title text-white p-2">
      <span>Add/Edit Employee</span>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="eduModal.hide()"
        style="color: black;">
        <span aria-hidden="true" class="">&times;</span>
      </button>
    </p> -->

<div mat-dialog-title style="position: relative;">
    <p class="ka-createEmp-header1">
        Add/Edit Employee
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
       (click)="onNoClick()" style="color: black; top: 0px;right: 15px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>
    
    <div class="dialog-window">
      
      <form [formGroup]="addEmployeeForm" (submit)="createEmployee($event)">
        <div class="scrollable-content">
        <div class="row">
          <div class="mb-3 col">
            <label for="fName" class="form-label ka-createEmp-label">First Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="firstName" id="fName" placeholder="">
          </div>
          <div class="mb-3 col">
            <label for="lName" class="form-label ka-createEmp-label">Last Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="lastName" id="lName" placeholder="    ">
          </div>
          <div class="mb-3 col">
            <label for="email" class="form-label ka-createEmp-label">Email</label>
            <input type="email" class="form-control" formControlName="email" id="email" placeholder="   ">
          </div>
          <div class="col mb-3">
            <div class="inputBox customMultiSelect">
            <label class="text-left ka-createEmp-label" for="">Working Branch <span class="text-danger">*</span> </label>
            <select id="workingBranch" formControlName="workingBranch" [ngModel]="empBranch" class="form-select ka-dropdown-singleSelect"
              aria-label="Default select example" (ngModelChange)="onBranchSelect($event)">
              <option value="">Select </option>
              <option class="select-option" *ngFor="let branch of branchesArray" [ngValue]="branch" >{{branch.name}}</option>      
            </select>
            <!-- <ng-multiselect-dropdown [placeholder]="'Branch'" [settings]="multiDropdownSettingsSingle1"
              class="ka-em-multiselect" [data]="branchArray" formControlName="workingBranch"
              (onSelect)="onBranchSelect($event)">
          </ng-multiselect-dropdown> -->
            </div>   
                    
          </div>
        </div>
        <div class="row">
          <div class="mb-3 col">
            <label for="officeLandline" class="form-label ka-createEmp-label">Office Landline</label>
            <input type="text" class="form-control" formControlName="officeLandline" id="officeLandline"
              placeholder="">
          </div>
          <div class="mb-3 col">
            <label for="officePhone" class="form-label ka-createEmp-label">Office Mobile</label>
            <input type="text" class="form-control" formControlName="officialPhone" id="officePhone"
              placeholder="   ">
          </div>

          <div class="col mb-3">
            <div class="inputBox customMultiSelect">
            <label class="text-left ka-createEmp-label" for="">Designation <span class="text-danger">*</span> </label>
            <!-- <select id="name" formControlName="designation" [ngModel]="designationName[0]['value']" class="form-select ka-dropdown-singleSelect"
              aria-label="Default select example">
              <option [ngValue]="null">Select </option>
              <option class="select-option" *ngFor="let designation of employeeDesignation" [ngValue]="designation">{{designation.value}}</option>      
            </select> -->
            <!-- <ng-multiselect-dropdown [placeholder]="'Designation'" [settings]="multiDropdownSettingsSingle"
              class="ka-em-multiselect" [data]="employeeDesignation" formControlName="designation"
              >
          </ng-multiselect-dropdown> -->
          <ng-multiselect-dropdown [placeholder]="'Designation'" [settings]="multiDropdownSettingsSingle"
          class="ka-em-multiselect" [data]="employeeTypeArray" formControlName="empType"
          >
      </ng-multiselect-dropdown>
            </div>           
          </div>
          <div class="col mb-3">
            <!-- <label class="text-left ka-createEmp-label ka-float-left " for="location">
              </label> -->
              <div class="col customMultiSelect p-0">
                <label class="text-left ka-createEmp-label ka-float-left " for="branch">
                  Login Location <span class="text-danger">*</span> </label>
                <ng-multiselect-dropdown [placeholder]="'Any'" [settings]="multiSelectRegionDropdown"
                  [data]="branchesArray" formControlName="loginLocation" (onSelect)="onBranchItemSelect($event)"
                  (onDeSelect)="onBranchItemDeSelect($event)" (onSelectAll)="onBrachItemsSelectAll($event)"
                  (onDeSelectAll)="onBranchDeSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <div class="inputBox customMultiSelect">
            <label class="text-left ka-createEmp-label" for="">Week-off <span class="text-danger">*</span> </label>
            <!-- <select id="name" formControlName="weekOff" class="form-select ka-dropdown-singleSelect"
              aria-label="Default select example">
              <option [ngValue]="null">Select</option>
              <option class="select-option" *ngFor="let day of weekOffArray" [ngValue]="day">{{day.value}}</option>      
            </select> -->
            <ng-multiselect-dropdown [placeholder]="'Week-off'" [settings]="multiDropdownSettingsSingle"
            class="ka-em-multiselect" [data]="weekOffArray" formControlName="weekOff"
            >
        </ng-multiselect-dropdown>
            </div>           
          </div>
          <div class="col" style="position:relative">
            <label class="ka-createEmp-label" for="">
              Date Of Joining <span class="text-danger">*</span>
            </label>
            <!-- <div class="">
              <input matInput [matDatepicker]="dateOfJoining" class="form-control ka-disabled"
                placeholder="Date Of Joining" formControlName="dateOfJoining"
               >
              <mat-datepicker-toggle matSuffix [for]="dateOfJoining" class="picker"></mat-datepicker-toggle>
              <mat-datepicker-toggle class="clear" matSuffix>
                <mat-icon matDatepickerToggleIcon><i class="fa fa-times"></i></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #dateOfJoining></mat-datepicker>
            </div> -->
            <div class="">
              <input matInput [matDatepicker]="dateOfJoining" class="form-control ka-disabled"
                  placeholder="Date of Joining" formControlName="dateOfJoining" (keypress)="onKeypressEvent($event)">
              <mat-datepicker-toggle matSuffix [for]="dateOfJoining"  class="picker"></mat-datepicker-toggle>
              <mat-datepicker #dateOfJoining></mat-datepicker>
              <!-- <div *ngIf="educationForm.controls['dob'].errors && !educationForm.controls['dob'].pristine "
                  class="error-msg1">
                  <div [hidden]="!educationForm.controls['dob'].errors.required">Date of Birth is
                      required.</div>

              </div> -->
          </div>
          </div>

          <div class="mb-3 col-3">
            <div  *ngIf="!isEdit">
            <label for="password" class="form-label ka-createEmp-label">Password <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="password" id="password" placeholder="">
          </div>
          </div>
          <div class="mb-3 col-3 d-flex justify-content-center align-items-center">
            <div  *ngIf="!isEdit">
                        <label for="loginName" class="form-label ka-createEmp-label">Login Name:</label>
                        <div *ngIf="employeeLoginId.length > 0">
                          <div class="ml-2">{{employeeLoginId[0]['LoginName']}}</div>
                          <!-- <input type="text" formControlName="loginName"> -->
                        </div>
                      </div>
                        </div>
          
          

        </div>
        <div class="row">
          <div class="col-3 mb-3">
            <div class="ka-createEmp-label">Office Hours From: <span class="text-danger">*</span></div>
            <div class="inputBox row customMultiSelect">
              <!-- <label class="text-left ka-createEmp-label" for="">Week-off <span class="text-danger">*</span> </label> -->
              <div class="col d-flex" style="height: 41px;">
              
              <!-- <select formControlName="officeHoursFrom" class="form-select col mr-3 ml-3 ka-dropdown-singleSelect"
                aria-label="Default select example">
                <option [ngValue]="null">Hrs</option>
                <option class="select-option" *ngFor="let hour of hoursArray" [ngValue]="hour">{{hour.value}}</option>      
              </select>
              <select formControlName="officeMinsFrom" class="form-select col ka-dropdown-singleSelect"
                aria-label="Default select example">
                <option [ngValue]="null">Mins</option>
                <option class="select-option" *ngFor="let min of minutesArray" [ngValue]="min">{{min.value}}</option>      
              </select> -->
              
                    <ng-multiselect-dropdown [placeholder]="'Hrs'" [settings]="multiDropdownSettingsSingle"
                        class="ka-em-multiselect col pl-0" [data]="hoursArray" formControlName="officeHoursFrom"
                        (onSelect)="onSelectData('hours',$event)">
                    </ng-multiselect-dropdown>
                    <ng-multiselect-dropdown [placeholder]="'Mins'" [settings]="multiDropdownSettingsSingle"
                        class="ka-em-multiselect col pr-0" [data]="minutesArray" formControlName="officeMinsFrom"
                        (onSelect)="onSelectData('munit',$event)">
                    </ng-multiselect-dropdown>
            </div>
            </div>
            </div>
            <div class="col-3 mb-3">
            <div class="ka-createEmp-label">Office Hours To: <span class="text-danger">*</span></div>
            <div class="inputBox row customMultiSelect">
            <div class="col d-flex" style="height: 41px;">
            
              <!-- <select formControlName="officeHoursTo" class="form-select col pl-0 mr-3 ka-dropdown-singleSelect"
                aria-label="Default select example">
                <option [ngValue]="null">Hrs</option>
                <option class="select-option" *ngFor="let hour of hoursArray" [ngValue]="hour">{{hour.value}}</option>      
              </select>
              <select formControlName="officeMinsTo" class="form-select col ka-dropdown-singleSelect"
                aria-label="Default select example">
                <option [ngValue]="null">Mins</option>
                <option class="select-option" *ngFor="let min of minutesArray" [ngValue]="min">{{min.value}}</option>      
              </select> -->
              <ng-multiselect-dropdown [placeholder]="'Hrs'" [settings]="multiDropdownSettingsSingle"
              class="ka-em-multiselect col pl-0 mr-3" [data]="hoursArray" formControlName="officeHoursTo"
              (onSelect)="onSelectData('hours',$event)">
          </ng-multiselect-dropdown>
          <ng-multiselect-dropdown [placeholder]="'Mins'" [settings]="multiDropdownSettingsSingle"
              class="ka-em-multiselect col pr-0" [data]="minutesArray" formControlName="officeMinsTo"
              (onSelect)="onSelectData('munit',$event)">
      </ng-multiselect-dropdown>
            </div>
            </div>
            </div>
          
          <div class="col-3 mb-3">
            <div class="ka-createEmp-label">Login Timings From: <span class="text-danger">*</span></div>
            <div class="inputBox row customMultiSelect">
              <!-- <label class="text-left ka-createEmp-label" for="">Week-off <span class="text-danger">*</span> </label> -->
              <div class="col d-flex" style="height: 41px;">
              
              <!-- <select formControlName="loginHoursFrom" class="form-select col pl-0 mr-3 ka-dropdown-singleSelect"
                aria-label="Default select example">
                <option [ngValue]="null">Hrs</option>
                <option class="select-option" *ngFor="let hour of hoursArray" [ngValue]="hour">{{hour.value}}</option>      
              </select>
              <select formControlName="loginMinsFrom" class="form-select col ka-dropdown-singleSelect"
                aria-label="Default select example">
                <option [ngValue]="null">Mins</option>
                <option class="select-option" *ngFor="let min of minutesArray" [ngValue]="min">{{min.value}}</option>      
              </select> -->
              <ng-multiselect-dropdown [placeholder]="'Hrs'" [settings]="multiDropdownSettingsSingle"
              class="ka-em-multiselect col pl-0 mr-3" [data]="hoursArray" formControlName="loginHoursFrom"
              (onSelect)="onSelectData('hours',$event)">
          </ng-multiselect-dropdown>
          <ng-multiselect-dropdown [placeholder]="'Mins'" [settings]="multiDropdownSettingsSingle"
              class="ka-em-multiselect col pr-0" [data]="minutesArray" formControlName="loginMinsFrom"
              (onSelect)="onSelectData('munit',$event)">
          </ng-multiselect-dropdown>
            </div>
            </div>
            </div>
            <div class="col-3 mb-3">
            <div class="ka-createEmp-label">Login Timings To: <span class="text-danger">*</span></div>
            <div class="inputBox row customMultiSelect">
            <div class="col d-flex" style="height: 41px;">
              
              <!-- <select formControlName="loginHoursTo" class="form-select col pl-0 mr-3 ka-dropdown-singleSelect"
                aria-label="Default select example">
                <option [ngValue]="null">Hrs</option>
                <option class="select-option" *ngFor="let hour of hoursArray" [ngValue]="hour">{{hour.value}}</option>      
              </select>
              <select formControlName="loginMinsTo" class="form-select col ka-dropdown-singleSelect"
                aria-label="Default select example">
                <option [ngValue]="null">Mins</option>
                <option class="select-option" *ngFor="let min of minutesArray" [ngValue]="min">{{min.value}}</option>      
              </select> -->
              <ng-multiselect-dropdown [placeholder]="'Hrs'" [settings]="multiDropdownSettingsSingle"
              class="ka-em-multiselect  col pl-0 mr-3" [data]="hoursArray" formControlName="loginHoursTo"
              (onSelect)="onSelectData('hours',$event)">
          </ng-multiselect-dropdown>
          <ng-multiselect-dropdown [placeholder]="'Mins'" [settings]="multiDropdownSettingsSingle"
              class="ka-em-multiselect col pr-0" [data]="minutesArray" formControlName="loginMinsTo"
              (onSelect)="onSelectData('munit',$event)">
          </ng-multiselect-dropdown>
            </div>
            </div>
          </div>
        
        </div>
        <div class="row">
          <div class="col-3 flexRows  d-flex align-items-center justify-content-center">
            <div class="inputBox customMultiSelect ka-createEmp-checkbox">
              <input type="checkbox" class="mx-2" name="" (click)="hideTeamLead($event)" id="check" formControlName="isTeamHead">
              <label class="text-left ka-createEmp-label" for="check">Team Head</label>
            </div>
          </div>
          <div class="col-3 mb-3" *ngIf="!hideTeamLeadField">
            <div class="inputBox customMultiSelect">
            <label class="text-left ka-createEmp-label" for="">Team Head <span class="text-danger">*</span> </label>
            <!-- <select id="name" formControlName="teamHead" class="form-select ka-dropdown-singleSelect"
              aria-label="Default select example">
              <option [ngValue]="null">Select</option>
              <option class="select-option" *ngFor="let head of teamHeadArray" [ngValue]="head">{{head.name}}</option>      
            </select> -->
            <ng-multiselect-dropdown [placeholder]="'Team-Head'" [settings]="multiDropdownSettingsSingle1"
            class="ka-em-multiselect" [data]="teamHeadArray" formControlName="teamHead"
            >
        </ng-multiselect-dropdown>
            </div>           
          </div>  
                    <!-- <div class="inputBox col-4 customMultiSelect">
            <p class="text-left ka-createEmp-label">Employee Type</p>
            <mat-radio-group class="pl-2 d-flex" formControlName="empType" style="justify-content: space-between;">
              <mat-radio-button class="arrival-date-type" [value]="1">Admin</mat-radio-button>
              <mat-radio-button class="arrival-date-type" [value]="2">Senior Emp</mat-radio-button>
              <mat-radio-button class="arrival-date-type" [value]="3">Review Emp</mat-radio-button>
              <mat-radio-button class="arrival-date-type" [value]="4">Marketing</mat-radio-button>
            </mat-radio-group>
          </div> -->


          <!-- <div class="col-3 mb-3">
            <div class="inputBox customMultiSelect">
            <label class="text-left ka-createEmp-label" for="">Employee Type <span class="text-danger">*</span> </label>
            <ng-multiselect-dropdown [placeholder]="'Employee Type'" [settings]="multiDropdownSettingsSingle"
            class="ka-em-multiselect" [data]="employeeTypeArray" formControlName="empType"
            >
        </ng-multiselect-dropdown>
            </div>           
          </div>       -->

        </div>
        <div class="row">

        </div>
        <div class="row mt-3 mb-3">
          <div class="col py-2 ka-createEmp-header">Employee Permissions</div>
        </div>
        <div class="row">      
          <div class="inputBox col-3 customMultiSelect">
            <p class="text-left ka-createEmp-label">Load Dashboard <span class="text-danger">*</span></p>
            <mat-radio-group class="pl-2 d-flex" formControlName="loadDashboard">
              <mat-radio-button class="arrival-date-type" [value]="1">Yes</mat-radio-button>
              <mat-radio-button class="arrival-date-type mx-1" [value]="0">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="col-3 flexRows  d-flex align-items-center justify-content-center">
            <div class="inputBox customMultiSelect ka-createEmp-checkbox2" style="padding: 11px 78px">
              <input type="checkbox" class="mx-2" name="" id="smartphone" formControlName="smartPhone">
              <label class="text-left ka-createEmp-label" for="smartphone">Smart Phone</label>
            </div>
          </div>
          
          <div class="col-3  d-flex align-items-center justify-content-center">
            <div class="inputBox customMultiSelect ka-createEmp-checkbox2" >
              <input type="checkbox" class="mx-2" name="anywhere" id="anywhere" formControlName="loginAnywhereCreate">
              <label class="text-left ka-createEmp-label" for="anywhere">Login Anywhere</label>
            </div>
          </div>
        </div>
        
        
        <div class="row mt-3 mb-3">
          <div class="col py-2 ka-createEmp-header">Personal Info</div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <!-- <div class="inputBox customMultiSelect"> -->
            <label class="text-left ka-createEmp-label" for="">Country  <span class="text-danger">*</span> </label>
            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="multiDropdownSettingsSingle"
                          class="ka-em-multiselect" [data]="countryArray" formControlName="country"
                          (onSelect)="selectedCountry($event)" (onDeSelect)="removeSelectedCountry()">
                      </ng-multiselect-dropdown>
            <!-- </div>            -->
          </div>
          <div class="col mb-3">
            <!-- <div class="inputBox customMultiSelect"> -->
            <label class="text-left ka-createEmp-label" for="">State <span class="text-danger">*</span></label>
            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="multiDropdownSettingsSingle"
                          class="ka-em-multiselect" [data]="stateArray" formControlName="state"
                          (onSelect)="selectedState($event)" (onDeSelect)="removeSelectedState()">
                      </ng-multiselect-dropdown>
            <!-- </div>            -->
          </div>
          <div class="col mb-3">
            <!-- <div class="inputBox customMultiSelect"> -->
            <label class="text-left ka-createEmp-label" for="">District <span class="text-danger">*</span></label>
            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="multiDropdownSettingsSingle"
                          class="ka-em-multiselect" [data]="districtArray" formControlName="district"
                          (onSelect)="selectedDistrict($event)" (onDeSelect)="removeSelectedDistrict()">
                      </ng-multiselect-dropdown>
            <!-- </div>            -->
          </div>
          <div class="col mb-3">
            <!-- <div class="inputBox customMultiSelect"> -->
            <label class="text-left ka-createEmp-label" for="">City <span class="text-danger">*</span></label>
            <ng-multiselect-dropdown *ngIf="!isInList" [placeholder]="'Select'"
            [settings]="multiDropdownSettingsSingle" class="ka-em-multiselect" [data]="cityArray"
            formControlName="city">
        </ng-multiselect-dropdown>
            <!-- </div>            -->
          </div>
        </div>
        <div class="row">

          <div class="mb-3 col-3">
            <label for="personalEmail" class="form-label ka-createEmp-label">Personal Email <span class="text-danger">*</span></label>
            <input type="personalEmail" class="form-control" formControlName="personalEmail" id="personalEmail"
              placeholder="   ">
          </div>
          <div class="mb-3 col-3">
            <label for="personalPhone" class="form-label ka-createEmp-label">Personal Mobile <span class="text-danger">*</span></label>
            <input type="personalPhone" class="form-control" formControlName="personalPhone" id="personalPhone"
              placeholder="   ">
          </div>
          <div class="col mb-3">
            <div class="inputBox customMultiSelect">
            <label class="text-left ka-createEmp-label" for="">Alternate Phone Relation <span class="text-danger">*</span> </label>
            <!-- <select id="name" formControlName="designation" [ngModel]="designationName[0]['value']" class="form-select ka-dropdown-singleSelect"
              aria-label="Default select example">
              <option [ngValue]="null">Select </option>
              <option class="select-option" *ngFor="let designation of employeeDesignation" [ngValue]="designation">{{designation.value}}</option>      
            </select> -->
            <ng-multiselect-dropdown [placeholder]="'Relation'" [settings]="multiDropdownSettingsSingle"
              class="ka-em-multiselect" [data]="employeeRelationArray" formControlName="empRelation"
              >
          </ng-multiselect-dropdown>
            </div>           
          </div>



          
          <div class="mb-3 col-3">
            <label for="alternatePhone" class="form-label ka-createEmp-label">Alternate Phone <span class="text-danger">*</span></label>
            <input type="alternatePhone" class="form-control" formControlName="alternatePhone" id="alternatePhone"
              placeholder="   ">
          </div>
        </div>
        <div class="row">
          <div class="mb-3 col-3">
            <label for="address" class="form-label ka-createEmp-label">Address <span class="text-danger">*</span></label>
            <textarea class="form-control" rows="3" cols="40" formControlName="address" id="address"
              placeholder=""></textarea>
          </div>
        </div>

        <div class="row mt-3 mb-3">
          <div class="col py-2 ka-createEmp-header">Education Details</div>
        </div>
        <div class="row">
          <div class="col-3 mb-3">
            <!-- <div class="inputBox customMultiSelect"> -->
            <label class="text-left ka-createEmp-label" for="educationCategory">Education Category</label>
            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="multiDropdownSettingsSingle"
            class="ka-em-multiselect" [data]="educationcategory" formControlName="educationCategory"
            (onSelect)="selectedEduCategory($event)">
        </ng-multiselect-dropdown>
            <!-- </div>            -->
          </div>
          <div class="col-3 mb-3">
            <!-- <div class="inputBox customMultiSelect"> -->
            <label class="text-left ka-createEmp-label" for="educationGroup">Education Group</label>
            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="multiDropdownSettingsSingle"
            class="ka-em-multiselect" [data]="educationGroupArray" formControlName="educationGroup"
            (onSelect)="selectedEduGrp($event)">
        </ng-multiselect-dropdown>
            <!-- </div>            -->
          </div>
          <div class="col-3 mb-3">
            <!-- <div class="inputBox customMultiSelect"> -->
            <label class="text-left ka-createEmp-label" for="educationSpecialization">Education Specialization</label>
            <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="multiDropdownSettingsSingle"
                          class="ka-em-multiselect" [data]="educationSepliziationArray"
                          formControlName="eduSpecialization">
                      </ng-multiselect-dropdown>
            <!-- </div>            -->
          </div>
       
        </div>
        <div class="row">
          <div class="form-group">
            <label for="file" class="ka-createEmp-label ml-3">Choose File : </label>
            <input type="file" (change)="uploadEmpImage($event)">
            <!-- <button (click)="submitEmpImage('VA018')" class></button> -->

        </div>
        <!-- <a mdbBtn class=" ka-white-button ka-outline-button mt-0 mb-5" style="    width: 152px;"
        routerLinkActive="router-link-active" color="" (click)="browseFiles()">Browse

        <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)"
          accept="image/png, image/jpeg,image/jpg,image/gif" />

      </a> -->
      <!-- <button mdbBtn class="ka-white-button tButton ka-btn-primary btn-success btn mb-4 mt-2 ka-normalButton-height"
      mdbWavesEffect type="submit" [disabled]="files.length < 1" (click)="uploadProfileImages()">Upload
      Photos
    </button> -->
      </div>
      <div mat-dialog-actions class="row" style="margin-top: 4%;">
        <div class="typeSection" >                       
          <button name="submit" class="ka-myProfile-viewType m-2 btn" [disabled]="!addEmployeeForm.valid" type="submit"> SUBMIT </button>
          <button type="button"  class=" m-2 reset-btn">RESET</button>      
          
      </div>
      </div>
      </div>
      </form>
    </div>
  </div>
  <div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true"
  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

      <div class="alert-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
              <span aria-hidden="true" class="alertClose">&times;</span>
          </button>
          <div class="row text-left">

              <!--Grid column-->
              <div class="col-md-12 rmSectionPopup">
                  <div class="row p-2 m-2">

                      <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                          <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                          <p class="mt-2 p-0">{{responseMessage}} </p>

                          <div class="action-buttons">
                              <button class="ka-myProfile-viewType"
                                   type="submit" (click)="closeDialog()">ok
                              </button>



                          </div>

                      </div>
                  </div>

              </div>

              <!--Grid column-->



          </div>
      </div>
  </div>
</div>

<div mdbModal #UplaodPhotoModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="UplaodPhotoModal.hide()">
        <span aria-hidden="true" class="alertClose">&times;</span>
      </button>
      <div class="row text-left">

        <!--Grid column-->
        <div class="col-md-12 rmSectionPopup">
          <div class="row p-2 m-2">

            <div class="col-md-12 rmDetailsSectionPopup">
              <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
              <p class="mt-2 p-0">{{data1._errorMessage}}</p>

              <div class="action-buttons">
                <button mdbBtn class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
                  type="submit" (click)="[UplaodPhotoModal.hide()]">ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>